import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UserGradeEnum } from '../../_utils/enums/user-grade.enum';
import { ComponentBase } from '../../_utils/component.base';
import { ModuleEnum } from '../../_utils/unums/module.enum';
import { IonPopover, ModalController } from '@ionic/angular';
import { SimulationsInfoModalComponent } from '../simulations-info-modal/simulations-info-modal.component';
import { SimulationProgressEnabledPipe } from 'src/app/_pipes/simulation-progress-enabled.pipe';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-simulation-list-header',
  templateUrl: './simulation-list-header.component.html',
  styleUrls: ['./simulation-list-header.component.scss'],
})
export class SimulationListHeaderComponent extends ComponentBase implements OnInit {

  @Input() typeOptions: string[] = [];
  @Input() showLevelsFilter: boolean = true;
  @Input()
  public simulations: any[];
  @Input()
  public module: ModuleEnum;

  levelSelectedNumber = 1;
  @Output() public selectedLevelHandler: EventEmitter<number> = new EventEmitter();
  @Output() public selectedTypeHandler: EventEmitter<any[]> = new EventEmitter();
  @Output() public filterHandler: EventEmitter<string>;
  @ViewChild('levelRequirementsPopover')
  protected levelRequirementsPopover: IonPopover;

  protected userGrade: UserGradeEnum;
  protected isOpenLevelRequirementPopover: boolean;
  protected levelRequirementsPayload: any;
  protected isDemo: boolean;
  protected filterControl: FormControl;

  constructor(public modalCtrl: ModalController, private simulationProgressEnabled: SimulationProgressEnabledPipe) {
    super();
    this.initVariables();
  }

  ngOnInit() {
    this.loadData().then();
  }

  public async levelSelected(level: number, event?: Event): Promise<void> {
    const simulationProgressSetting = await this.userJourneyService.getSimulationProgressSetting();
    const isEnabledLevel = await this.simulationProgressEnabled.transform(level, this.simulations, this.module, 'avatar', simulationProgressSetting);
    if (isEnabledLevel) {
      this.levelSelectedNumber = level;
      this.selectedLevelHandler.emit(level);
    } else {
      this.levelRequirementsPopover.event = event;
      this.isOpenLevelRequirementPopover = true;
      const previousLevel = level - 1;
      const userGrade = await this.userJourneyService.getUserGrade(this.module);
      const simulationsRequirements = (await this.userJourneyService.getSimulationProgressSetting()).avatar
        .find(x => x.userGrade === userGrade).config
        .find(x => x.level === previousLevel)?.value;
      this.levelRequirementsPayload = {
        level,
        previousLevel,
        simulationsRequirements
      };
    }
  }

  public typeSelectedEvent(event) {
    let value = event.detail.value;
    this.selectedTypeHandler.emit(value);
  }

  async openInfoModal() {
    const modal = await this.modalCtrl.create({
      component: SimulationsInfoModalComponent,
      backdropDismiss: true,
      cssClass: 'simulations-list-info-modal',
      componentProps: {module: this.module}
    });

    return await modal.present();
  }

  private initVariables(): void {
    this.isOpenLevelRequirementPopover = false;
    this.filterHandler = new EventEmitter();
    this.filterControl = new FormControl();
    this.filterControl.valueChanges.subscribe(value => this.filterHandler.emit(value));
  }

  private async loadData(): Promise<void> {
    [this.isDemo] = await Promise.all([this.userJourneyService.isDemo()]);
  }
}
